// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aircraft-lighting-see-and-avoid.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aircraft-lighting-see-and-avoid/aircraft-lighting-see-and-avoid.js';

mount([g0]);
